<form *ngIf="employeeDirectDeposit" [formGroup]="directDepositForm">
  <div class="form-row">
    <!-- direct deposit name -->
    <div class="col-4">
      <small>{{ getMaskedAcctNo(employeeDirectDeposit.AccountNumber) }}</small>
    </div>

    <!-- direct deposit account type -->
    <div class="col-4 px-3">
      <small>{{ getCalculationType(employeeDirectDeposit.CalculationMethod) }}</small>
    </div>

    <!-- direct deposit amount -->
    <div class="col-4">
      <div class="input-group">
        <input
          class="form-control"
          formControlName="amount"
          (keyup)="onAmountChange($event)"
          id="column-5-row-{{ rowIndex }}"
          appNumberInput
          [attr.disabled]="directDepositForm.controls.amount.disabled ? 'disabled' : null" />
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
      </div>
    </div>
  </div>
</form>
